module.exports = __webpack_public_path__ + "img/10c-analises-atendimento-concluir.ec5a01d2.png";